module.exports = __webpack_public_path__ + "ecb0370ac1623b3bd72cd31c03540ac1.svg";